import {Spinner} from '@wix/wix-ui-tpa/cssVars'
import React from 'react'
import {classes} from './spinner.st.css'

export const SpinnerExt = props => <Spinner {...props} className={classes.root} />
